/** 采购管理主入口，沿用 Vue index.vue 的页面闭合集合，仅渲染页面标题。 */
export function PurchasingManagePage() {
    return (
        <section aria-label="purchasing-manage-page">
            <h1>采购管理</h1>
        </section>
    );
}
